import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { navigate } from './router.js'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  readonly to: string
  readonly children: ReactNode
}

/**
 * A real anchor, so middle-click and "open in new tab" keep working, but a
 * plain click goes through the router — that is where the unsaved-changes
 * guard lives.
 */
export const Link = ({ to, children, onClick, ...rest }: LinkProps) => (
  <a
    href={to}
    onClick={(e) => {
      onClick?.(e)
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return
      e.preventDefault()
      navigate(to)
    }}
    {...rest}
  >
    {children}
  </a>
)
